import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["loaderHandler"];
import React from 'react';
import compose from 'recompose/compose';
import setDisplayName from 'recompose/setDisplayName';
import PropTypes from 'prop-types';
import getHOCDisplayName from "../../../service/getHOCDisplayName";
import DebounceLoader from "./DebounceLoader";
import LoaderContext, { loaderContextShape } from "./LoaderContext";
import withLoaderState from "./withLoaderState";
var defaultLoader = function defaultLoader(content) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    bounceTimeout: 1000,
    loaded: false
  };
  return /*#__PURE__*/React.createElement(DebounceLoader, {
    bounceTimeout: options.bounceTimeout,
    loaded: options.loaded
  }, content);
};
var withLoaderProvider = function withLoaderProvider(WrappedComponent) {
  var bounceTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var loaderRenderer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultLoader;
  var loadedDefault = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var LoaderProviderWrapper = function LoaderProviderWrapper(_ref) {
    var loaderHandler = _ref.loaderHandler,
      restProps = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/React.createElement(LoaderContext.Provider, {
      value: loaderHandler
    }, loaderRenderer( /*#__PURE__*/React.createElement(WrappedComponent, _extends({
      loaderHandler: loaderHandler
    }, restProps)), {
      loaded: loaderHandler.isLoaded(),
      bounceTimeout: bounceTimeout
    }));
  };
  LoaderProviderWrapper.propTypes = {
    loaderHandler: PropTypes.shape(loaderContextShape).isRequired
  };
  return compose(setDisplayName(getHOCDisplayName(WrappedComponent, 'withLoaderProvider')))(withLoaderState(LoaderProviderWrapper, loadedDefault));
};
export default withLoaderProvider;